import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/kesling/audit";

function handle<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

const getList = (params?: any) =>
  handle(http.getDataParam(`${BASE}/sessions`, params));
const find = (id: number) => handle(http.getData(`${BASE}/sessions/${id}`));
const create = (data: any) => handle(http.postData(`${BASE}/sessions`, data));
const update = (id: number, data: any) =>
  handle(http.putData(`${BASE}/sessions/${id}`, data));
const destroy = (id: number) =>
  handle(http.deleteData(`${BASE}/sessions/${id}`));

const updateItemsBulk = (id: number, items: any[]) =>
  handle(http.putData(`${BASE}/sessions/${id}/items/bulk`, { items }));

// 2-tier sign: Auditor → Petugas Jaga (acknowledgement)
const submitAuditor = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/submit-auditor`, data));
const acknowledgePetugasJaga = (id: number, data: { password: string }) =>
  handle(http.postData(`${BASE}/sessions/${id}/acknowledge-petugas-jaga`, data));

const printPdf = (id: number) => {
  window.open(`${http.getAPI()}${BASE}/sessions/${id}/pdf`, "_blank");
};

export default {
  getList,
  find,
  create,
  update,
  destroy,
  updateItemsBulk,
  submitAuditor,
  acknowledgePetugasJaga,
  printPdf
};
